<div class="compare-header">
  <div class="compare-first-row">
    <div
      class="compare-back"
      *ngIf="(platformService.isTouchExperience$ | async) === false"
      (click)="redirectToSearch()"
    >
      <ion-icon
        name="chevron-back-outline"
        data-cy="compare-product-button-icon"
      >
      </ion-icon>
      <span>
        {{
          'i18n.search.returnTo'
            | translate: { previousSection: sectionToGoBack }
        }}
      </span>
    </div>
    <section
      class="compare-icons-section"
      *ngIf="!isMobile && !isTablet && !isGuestUser"
    >
      <ng-container *ngTemplateOutlet="compareDownloadSection"></ng-container>
      <ng-container *ngTemplateOutlet="comparePrintSection"></ng-container>
      <ng-container *ngTemplateOutlet="compareShareSection"></ng-container>
    </section>
  </div>
  <div
    class="compare-title"
    *ngIf="(platformService.isTouchExperience$ | async) === false"
  >
    <h1>{{ 'i18n.search.searchCompare.title' | translate }}</h1>
  </div>
</div>
<!--Scroll bar-->
<div class="pc-table">
  <div class="clean-sticky-jumping">
    <div class="product-popover-list" *ngIf="shouldConvertToPopover">
      <div class="pp-details">
        <div class="pp-card pp-placeholder"></div>
        <div class="pp-card pp-card-unit">
          <app-product-comparison-popover
            *ngFor="let product of productsDetails; let i = index"
            [productDetails]="product"
            (closeCardEmitter)="onCloseCard($event)"
            [cardsNumber]="productsDetails.length"
            [isActionable]="
              product && product?.productNumber !== originalItemNumber
            "
            [productIndex]="i"
            [isGuestUser]="isGuestUser"
          ></app-product-comparison-popover>
        </div>
      </div>
    </div>
  </div>
  <div class="sticky-compare-section" *ngIf="!isGuestUser">
    <ng-container
      *appShowSplit="
        [printFeatureFlag, downloadFeatureFlag, shareFeatureFlag];
        allEnabled: false
      "
    >
      <section
        class="compare-icons"
        [class.popover]="shouldConvertToPopover"
        *ngIf="isMobile || isTablet"
      >
        <div
          data-cy="product-card-ellipsis-section"
          class="ellipsis"
          *ngIf="isMobile"
          (click)="ellipsisClick($event)"
        >
          <ion-icon
            data-cy="product-card-ellipsis-icon"
            name="ellipsis-vertical-circle-sharp"
          ></ion-icon>
        </div>
        <div class="compare-icons-section" *ngIf="isTablet">
          <ng-container
            *ngTemplateOutlet="compareDownloadSection"
          ></ng-container>
          <ng-container *ngTemplateOutlet="comparePrintSection"></ng-container>
          <ng-container *ngTemplateOutlet="compareShareSection"></ng-container>
        </div>
      </section>
    </ng-container>
  </div>
  <div class="pc-row" *ngIf="!shouldConvertToPopover">
    <div class="pc-row-content">
      <div class="pc-cell ce-placeholder"></div>
      <div
        class="pc-details"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        cdkDropListOrientation="horizontal"
        [cdkDropListSortPredicate]="
          originalItemNumber ? sortPredicate : noOpSortPredicate
        "
      >
        <div
          class="pc-cell pc-card"
          *ngFor="let product of productsDetails; let i = index"
          cdkDrag
          id="productCard-{{ product?.productNumber }}"
        >
          <app-product-detail-card
            [productDetails]="product"
            (quantityUpdateEmitter)="onQuantityUpdate($event)"
            (closeCardEmitter)="onCloseCard($event)"
            [cardsNumber]="productsDetails.length"
            [navigationDisabled]="
              (orderService.restrictNavigationForCurrentOrder$ | async) || false
            "
            [isActionable]="
              product && product?.productNumber !== originalItemNumber
            "
            [listState]="listState"
            [selectedProducts]="selectedProducts"
            [originalItemNumber]="originalItemNumber"
            [mode]="mode"
            [isGuestUser]="isGuestUser"
            (selectOrderSub)="selectOrderSubstitute($event)"
            (selectExceptionSub)="selectExceptionSubstitute($event)"
            (selectBetterBuySub)="acceptSwap($event)"
          >
            <button class="drag-button">
              <ion-icon name="menu-outline" cdkDragHandle></ion-icon>
            </button>
            <div class="custom-placeholder" *cdkDragPlaceholder></div>
          </app-product-detail-card>
        </div>
      </div>
    </div>
  </div>
  <div class="pc-row">
    <div class="pc-row-header bold">
      {{ 'i18n.search.searchCompare.brand' | translate }}
    </div>
    <div class="pc-row-content">
      <div class="pc-cell ce-placeholder"></div>
      <div class="pc-details">
        <div
          class="pc-cell"
          *ngFor="let product of productsDetails; let i = index"
        >
          <div *ngIf="i !== 0" class="pc-cell-separator"></div>
          <span>
            {{
              (product?.summary?.brand ? product?.summary?.brand : 'N/A')
                | acronymTitleCase
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!isGuestUser" class="pc-row" data-cy="compare-product-price-row">
    <div class="pc-row-header bold">
      {{ 'i18n.search.searchCompare.price' | translate }}
    </div>
    <div class="pc-row-content">
      <div class="pc-cell ce-placeholder">
        <span class="pc-row-subheader bold">{{
          'i18n.search.searchCompare.cases' | translate
        }}</span>
        <span class="pc-row-subheader bold">{{
          'i18n.search.searchCompare.eaches' | translate
        }}</span>
      </div>
      <div class="pc-details">
        <div
          class="pc-cell"
          *ngFor="let product of productsDetails; let i = index"
        >
          <div *ngIf="i !== 0" class="pc-cell-separator"></div>
          <div
            class="multi-line-cell"
            *ngIf="
              product &&
                !product?.summary?.properties?.has(propertiesEnum.specialOrder);
              else specialOrder
            "
          >
            <div id="casePrice-{{ product?.productNumber }}">
              <span *ngIf="product?.pricing?.unitPrice * 1 > 0">
                {{ (product?.pricing?.unitPrice | currency) || 'loading..' }}
                {{ product?.summary?.priceUom || 'CS' }}
              </span>
              <span *ngIf="product?.pricing?.unitPrice * 1 === 0">
                {{ 'i18n.search.searchCompare.noPrice' | translate }}
              </span>
            </div>
            <div id="eachPrice-{{ product?.productNumber }}">
              <span *ngIf="!product?.summary?.breakable">N/A</span>
              <span *ngIf="product?.summary?.breakable">
                <span *ngIf="product?.pricing?.eachPrice * 1 > 0">
                  {{ (product?.pricing?.eachPrice | currency) || 'loading..' }}
                  {{
                    (product?.summary?.catchWeightFlag
                      ? product?.summary?.priceUom
                      : product?.summary?.eachUom) || 'EA'
                  }}
                </span>
                <span *ngIf="product?.pricing?.eachPrice * 1 === 0">
                  {{ 'i18n.search.searchCompare.noPrice' | translate }}
                </span>
              </span>
            </div>
          </div>
          <ng-template #specialOrder>
            <span id="specialPrice-{{ product?.productNumber }}">{{
              'i18n.search.searchCompare.specialOrderProductMessage' | translate
            }}</span>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div class="pc-row">
    <div class="pc-row-header bold">
      {{ 'i18n.search.searchCompare.packSize' | translate }}
    </div>
    <div class="pc-row-content">
      <div class="pc-cell ce-placeholder"></div>
      <div class="pc-details">
        <div
          class="pc-cell"
          *ngFor="let product of productsDetails; let i = index"
        >
          <div *ngIf="i !== 0" class="pc-cell-separator"></div>
          <span>
            {{
              product?.summary?.salesPackSize
                ? product?.summary?.salesPackSize
                : 'N/A'
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="!isGuestUser"
    class="pc-row"
    data-cy="compare-product-per-portion-price-row"
  >
    <div class="pc-row-header bold">
      {{ 'i18n.search.searchCompare.pricePerPortion' | translate }}
    </div>
    <div class="pc-row-content">
      <div class="pc-cell ce-placeholder"></div>
      <div class="pc-details">
        <div
          class="pc-cell"
          *ngFor="let product of productsDetails; let i = index"
        >
          <div *ngIf="i !== 0" class="pc-cell-separator"></div>
          <div id="pricePerPortion-{{ product?.productNumber }}">
            <ng-container
              *ngIf="
                !product?.summary?.properties?.has(propertiesEnum.specialOrder);
                else notApplicable
              "
            >
              <ng-container *ngIf="!product?.summary?.catchWeightFlag">
                <span *ngIf="!!product?.costBreakdown; else notApplicable">
                  {{ product?.costBreakdown }}
                </span>
              </ng-container>
              <ng-container *ngIf="product?.summary?.catchWeightFlag">
                <span
                  *ngIf="
                    product?.pricing?.unitPrice * 1 > 0;
                    else notApplicable
                  "
                >
                  {{ (product?.pricing?.unitPrice | currency) || 'loading..' }}
                  /
                  {{ product?.summary?.priceUom || 'LB' }}
                </span>
              </ng-container>
            </ng-container>
            <ng-template #notApplicable>
              <span>N/A</span>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="!isGuestUser"
    class="pc-row"
    data-cy="compare-product-available-inventory-row"
  >
    <div class="pc-row-header bold">
      {{ 'i18n.search.searchCompare.availableInventory' | translate }}
    </div>
    <div class="pc-row-content">
      <div class="pc-cell ce-placeholder">
        <span class="pc-row-subheader bold">{{
          'i18n.search.searchCompare.cases' | translate
        }}</span>
        <span class="pc-row-subheader bold">{{
          'i18n.search.searchCompare.eaches' | translate
        }}</span>
      </div>
      <div class="pc-details">
        <div
          class="pc-cell"
          *ngFor="let product of productsDetails; let i = index"
        >
          <div *ngIf="i !== 0" class="pc-cell-separator"></div>
          <div class="multi-line-cell">
            <span
              id="casesInventory-{{ product?.productNumber }}"
              [ngClass]="{
                'out-of-stock':
                  inventoryCSMessageMap?.get(product?.productNumber) ===
                  'i18n.search.searchCompare.outOfStock',
              }"
            >
              {{
                inventoryCSMessageMap?.get(product?.productNumber) | translate
              }}
            </span>
            <span
              id="eachesInventory-{{ product?.productNumber }}"
              [ngClass]="{
                'out-of-stock':
                  inventoryEAMessageMap?.get(product?.productNumber) ===
                  'i18n.search.searchCompare.outOfStock',
              }"
            >
              {{
                inventoryEAMessageMap?.get(product?.productNumber) | translate
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pc-row">
    <div class="pc-row-header bold">
      {{ 'i18n.search.searchCompare.productAttributes' | translate }}
    </div>
    <div class="pc-row-content">
      <div class="pc-cell ce-placeholder"></div>
      <div class="pc-details">
        <div
          class="pc-cell"
          *ngFor="let product of productsDetails; let i = index"
        >
          <div *ngIf="i !== 0" class="pc-cell-separator"></div>
          <app-product-comparison-product-attributes
            [productDetails]="product"
            [isGuestUser]="isGuestUser"
            class="multi-line-cell"
            id="productAttributes-{{ product?.productNumber }}"
          ></app-product-comparison-product-attributes>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="!isGuestUser"
    class="pc-row"
    data-cy="compare-product-purchase-history-row"
  >
    <div class="pc-row-header bold">
      {{ 'i18n.search.searchCompare.purchaseHistory' | translate }}
    </div>
    <div class="pc-row-content">
      <div class="pc-cell ce-placeholder"></div>
      <div class="pc-details">
        <div
          class="pc-cell"
          *ngFor="let product of productsDetails; let i = index"
        >
          <div *ngIf="i !== 0" class="pc-cell-separator"></div>
          <div
            class="multi-line-cell"
            id="purchaseHistory-{{ product?.productNumber }}"
          >
            <span *ngFor="let purchase of getPurchaseHistory(product)">{{
              purchase
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pc-row">
    <div class="pc-row-header bold">
      {{ 'i18n.search.searchCompare.netWeight' | translate }}
    </div>
    <div class="pc-row-content">
      <div class="pc-cell ce-placeholder"></div>
      <div class="pc-details">
        <div
          class="pc-cell"
          *ngFor="let product of productsDetails; let i = index"
        >
          <div *ngIf="i !== 0" class="pc-cell-separator"></div>
          <span id="netWeight-{{ product?.productNumber }}">
            {{
              product?.detail?.netWeight
                ? product?.detail?.netWeight + ' ' + product?.detail?.weightUom
                : 'N/A'
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="pc-row">
    <div class="pc-row-header bold">
      {{ 'i18n.search.searchCompare.usfStorage' | translate }}
    </div>
    <div class="pc-row-content">
      <div class="pc-cell ce-placeholder"></div>
      <div class="pc-details">
        <div
          class="pc-cell"
          *ngFor="let product of productsDetails; let i = index"
        >
          <div *ngIf="i !== 0" class="pc-cell-separator"></div>
          <span id="usfStorage-{{ product?.productNumber }}">
            {{
              product?.detail?.storageCodeDescription
                ? product?.detail?.storageCodeDescription +
                  ' ' +
                  product?.summary?.productStorageCode
                : 'N/A'
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="pc-row">
    <div class="pc-row-header bold">
      {{ 'i18n.search.searchCompare.ingredients' | translate }}
    </div>
    <div class="pc-row-content">
      <div class="pc-cell ce-placeholder"></div>
      <div class="pc-details">
        <div
          class="pc-cell"
          *ngFor="let product of productsDetails; let i = index"
        >
          <div *ngIf="i !== 0" class="pc-cell-separator"></div>
          <p>
            {{
              product?.detail?.ingredients
                ? product?.detail?.ingredients + ' '
                : 'N/A'
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="pc-row">
    <div class="pc-row-header bold">
      {{ 'i18n.search.searchCompare.nutritionalFacts' | translate }}
    </div>
    <div class="pc-row-content">
      <div class="pc-cell ce-placeholder"></div>
      <div class="pc-details">
        <table>
          <tbody>
            <tr>
              <td
                *ngFor="let product of productsDetails; let first = first"
                class="nutrition-cell"
                [ngClass]="{ 'first-column': first }"
              >
                <span *ngIf="!product?.nutritionFacts?.nutrientIsNotAvailable">
                  Serving Size: {{ product?.nutritionFacts?.servingSizeData }}
                </span>
                <span *ngIf="product?.nutritionFacts?.nutrientIsNotAvailable">
                  N/A
                </span>
              </td>
            </tr>

            <tr class="nutrition-row-bottom">
              <td
                *ngFor="let product of productsDetails; let first = first"
                class="nutrition-cell"
                [ngClass]="{ 'first-column': first }"
              >
                <span *ngIf="!product?.nutritionFacts?.nutrientIsNotAvailable">
                  Serving Per Container: {{ product?.detail?.servingsPerCase }}
                </span>
                <span *ngIf="product?.nutritionFacts?.nutrientIsNotAvailable">
                  N/A
                </span>
              </td>
            </tr>
          </tbody>

          <tbody class="nutrition-group">
            <tr class="nutrition-row-bottom">
              <ng-container
                *ngFor="let product of productsDetails; let first = first"
              >
                <ng-container *ngIf="!product?.isUsda; else usdaCalories">
                  <td
                    class="nutrition-cell"
                    [ngClass]="{ 'first-column': first }"
                  >
                    <span
                      *ngIf="!product?.nutritionFacts?.nutrientIsNotAvailable"
                    >
                      Calories: {{ product?.nutritionFacts?.calories }}
                    </span>
                    <span
                      *ngIf="product?.nutritionFacts?.nutrientIsNotAvailable"
                    >
                      N/A
                    </span>
                  </td>
                </ng-container>
                <ng-template #usdaCalories>
                  <td
                    class="nutrition-cell"
                    [ngClass]="{ 'first-column': first }"
                  >
                    <div
                      *ngIf="!product?.nutritionFacts?.nutrientIsNotAvailable"
                      style="padding-bottom: 0.5rem"
                    >
                      Calories: {{ product?.nutritionFacts?.calories }}
                    </div>
                    <div
                      *ngIf="!product?.nutritionFacts?.nutrientIsNotAvailable"
                    >
                      Calories From Fat:
                      {{ product?.nutritionFacts?.caloriesFromFat }}
                    </div>
                    <span
                      *ngIf="product?.nutritionFacts?.nutrientIsNotAvailable"
                    >
                      N/A
                    </span>
                  </td>
                </ng-template>
              </ng-container>
            </tr>
          </tbody>

          <tbody class="nutrition-group">
            <tr
              *ngFor="
                let index of ['Total Fat', 'Saturated Fat', 'Trans Fat'];
                let last = last
              "
              [ngClass]="{ 'nutrition-row-bottom': last }"
            >
              <td
                *ngFor="let product of productsDetails; let first = first"
                class="nutrition-cell"
                [ngClass]="{ 'first-column': first }"
              >
                <span *ngIf="!product?.nutritionFacts?.nutrientIsNotAvailable">
                  <ng-container
                    [ngTemplateOutlet]="nutrientTemplate"
                    [ngTemplateOutletContext]="{
                      productNumber: product?.productNumber,
                      productNutrient: getNutrientByName(product, index),
                    }"
                  ></ng-container>
                </span>
                <span *ngIf="product?.nutritionFacts?.nutrientIsNotAvailable">
                  N/A
                </span>
              </td>
            </tr>
          </tbody>
          <tbody class="nutrition-group">
            <tr class="nutrition-row-bottom">
              <td
                *ngFor="let product of productsDetails; let first = first"
                class="nutrition-cell"
                [ngClass]="{ 'first-column': first }"
              >
                <span *ngIf="!product?.nutritionFacts?.nutrientIsNotAvailable">
                  <ng-container
                    [ngTemplateOutlet]="nutrientTemplate"
                    [ngTemplateOutletContext]="{
                      productNumber: product?.productNumber,
                      productNutrient: getNutrientByName(
                        product,
                        'Cholesterol'
                      ),
                    }"
                  ></ng-container>
                </span>
                <span *ngIf="product?.nutritionFacts?.nutrientIsNotAvailable">
                  N/A
                </span>
              </td>
            </tr>
          </tbody>
          <tbody class="nutrition-group">
            <tr class="nutrition-row-bottom">
              <td
                *ngFor="let product of productsDetails; let first = first"
                class="nutrition-cell"
                [ngClass]="{ 'first-column': first }"
              >
                <span *ngIf="!product?.nutritionFacts?.nutrientIsNotAvailable">
                  <ng-container
                    [ngTemplateOutlet]="nutrientTemplate"
                    [ngTemplateOutletContext]="{
                      productNumber: product?.productNumber,
                      productNutrient: getNutrientByName(product, 'Sodium'),
                    }"
                  ></ng-container>
                </span>
                <span *ngIf="product?.nutritionFacts?.nutrientIsNotAvailable">
                  N/A
                </span>
              </td>
            </tr>
          </tbody>
          <tbody class="nutrition-group">
            <tr
              *ngFor="
                let index of [
                  'Total Carbohydrate',
                  'Dietary Fiber',
                  'Total Sugar',
                  'Added Sugars',
                ];
                let last = last
              "
              [ngClass]="{ 'nutrition-row-bottom': last }"
            >
              <td
                *ngFor="let product of productsDetails; let first = first"
                class="nutrition-cell"
                [ngClass]="{ 'first-column': first }"
              >
                <span *ngIf="!product?.nutritionFacts?.nutrientIsNotAvailable">
                  <ng-container
                    [ngTemplateOutlet]="nutrientTemplate"
                    [ngTemplateOutletContext]="{
                      productNumber: product?.productNumber,
                      productNutrient: getNutrientByName(product, index),
                    }"
                  ></ng-container>
                </span>
                <span *ngIf="product?.nutritionFacts?.nutrientIsNotAvailable">
                  N/A
                </span>
              </td>
            </tr>
          </tbody>

          <tbody class="nutrition-group">
            <tr class="nutrition-row-bottom">
              <td
                *ngFor="let product of productsDetails; let first = first"
                class="nutrition-cell"
                [ngClass]="{ 'first-column': first }"
              >
                <span *ngIf="!product?.nutritionFacts?.nutrientIsNotAvailable">
                  <ng-container
                    [ngTemplateOutlet]="nutrientTemplate"
                    [ngTemplateOutletContext]="{
                      productNumber: product?.productNumber,
                      productNutrient: getNutrientByName(product, 'Protein'),
                    }"
                  ></ng-container>
                </span>
                <span *ngIf="product?.nutritionFacts?.nutrientIsNotAvailable">
                  N/A
                </span>
              </td>
            </tr>
          </tbody>
          <tbody class="nutrition-group">
            <tr
              *ngFor="let index of [0, 1, 2, 3]; let last = last"
              [ngClass]="{ 'nutrition-row-bottom': last }"
            >
              <td
                *ngFor="let product of productsDetails; let first = first"
                class="nutrition-cell"
                [ngClass]="{ 'first-column': first }"
              >
                <span *ngIf="!product?.nutritionFacts?.nutrientIsNotAvailable">
                  <ng-container
                    *ngIf="!product?.isUsda"
                    [ngTemplateOutlet]="nutrientTemplate"
                    [ngTemplateOutletContext]="{
                      productNumber: product?.productNumber,
                      productNutrient: getNutrientByName(
                        product,
                        extraNutrientsLabels[index]
                      ),
                    }"
                  ></ng-container>
                  <ng-container
                    *ngIf="product?.isUsda"
                    [ngTemplateOutlet]="nutrientPercentageTemplate"
                    [ngTemplateOutletContext]="{
                      productNumber: product?.productNumber,
                      productNutrient: getNutrientByName(
                        product,
                        extraNutrientsLabelsUsda[index]
                      ),
                    }"
                  ></ng-container>
                </span>
                <span *ngIf="product?.nutritionFacts?.nutrientIsNotAvailable">
                  N/A
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<ng-template
  #nutrientTemplate
  let-productNumber="productNumber"
  let-productNutrient="productNutrient"
>
  <ng-container *ngIf="productNutrient">
    <div
      id="nutrientsData-{{ productNutrient?.data?.nutrientName }}-{{
        productNumber
      }}"
    >
      {{ productNutrient?.data?.nutrientName }}:
      {{ productNutrient?.data?.nutrientValue }}
      <span *ngIf="productNutrient?.data?.nutrientValue !== null">
        {{ productNutrient?.data?.nutrientUom }}
      </span>
    </div>
  </ng-container>
</ng-template>
<ng-template
  #nutrientPercentageTemplate
  let-productNumber="productNumber"
  let-productNutrient="productNutrient"
>
  <ng-container *ngIf="productNutrient">
    <div
      id="nutrientsData-{{ productNutrient?.data?.nutrientName }}-{{
        productNumber
      }}"
    >
      {{ productNutrient?.data?.nutrientName }}:
      {{ productNutrient?.data?.nutrientRdvPercentage
      }}<span *ngIf="productNutrient?.data?.nutrientRdvPercentage !== null"
        >%</span
      >
    </div>
  </ng-container>
</ng-template>

<ng-template #compareShareSection>
  <ng-container *appShowSplit="[shareFeatureFlag]">
    <div class="compare-icons-share" (click)="onShareButtonPress()">
      <ion-icon name="share-social-outline"></ion-icon>
      <span class="text">
        {{ 'i18n.common.share' | translate }}
      </span>
    </div>
  </ng-container>
</ng-template>
<ng-template #comparePrintSection>
  <ng-container *appShowSplit="[printFeatureFlag]">
    <div class="compare-icons-print" (click)="onPrintButtonPress()">
      <ion-icon name="print-outline"> </ion-icon>
      <span class="text">
        {{ 'i18n.common.print' | translate }}
      </span>
    </div>
  </ng-container>
</ng-template>

<ng-template #compareDownloadSection>
  <ng-container *appShowSplit="[downloadFeatureFlag]">
    <div class="compare-icons-download" (click)="onDownloadButtonPress()">
      <ion-icon name="download-outline"> </ion-icon>
      <span class="text">
        {{ 'i18n.common.download' | translate }}
      </span>
    </div>
  </ng-container>
</ng-template>
